"use client";
import React from "react";
import Image from "next/image";
import { PortableText } from "@portabletext/react";
import { customRichTextComponent } from "@/sanity/sanityPortableText";
import { motion } from "framer-motion";
import NavBarV2 from "@/components/global/partials/HeaderV2";
import type { PageAffiliateV2Schema } from "@/sanity/pages/PageAffiliateV2Template";
import Hero from "../pageComponents/affiliate-v2/Hero";
import ExclusiveSection from "../pageComponents/affiliate-v2/Exclusive";
import Deals from "../pageComponents/affiliate-v2/Deals";
import Rules from "../pageComponents/affiliate-v2/Rules";
import bg from "@/public/home/section-bg.jpg";
import Payouts from "../pageComponents/affiliate-v2/Payouts";
import ReviewsSection from "../pageComponents/challenge/Reviews";
import StepsSection from "../pageComponents/affiliate-v2/Steps";
import LastCTASection from "../global/sections/LastCTA";
import Footer from "../global/partials/Footer";
import { cn } from "@/lib/utils";
import trading from "@/public/global/trading-de.png";
import LastCTACompetitionSection from "../pageComponents/comp-affiliate-v2/LastCTACompetition";

export default function PageAffiliateV2JSX({
  data,
}: {
  data: PageAffiliateV2Schema;
}) {
  return (
    <>
      <main className="">
        {data?.settings.header && (
          <NavBarV2 headerData={data?.settings.header} />
        )}
        <Hero data={data} />

        <ExclusiveSection
          data={data}
          className={`${data?.showReviewButton ? "pb-[7rem] lg:pb-[20rem]" : "py-[7rem] lg:py-[20rem]"}`}
        />
        <Deals data={data} />

        <Rules data={data} />

        <Payouts data={data} />
        <div className="w-full px-[2rem]">
          <div className="bg-[#FCFDFD] border border-[#E5E5E580] rounded-[1.5rem] lg:rounded-[5rem] w-[min(230rem,100%)] mx-auto">
            <ReviewsSection
              reviewsTitle={data.reviewsTitle}
              reviewsDocument={data.reviewsDocument}
              fadeColor="white"
              slug={data?.settings?.slug?.current}
              cardTheme="white"
            />
          </div>
        </div>

        <StepsSection data={data} />

        <LastCTACompetitionSection
          chip={data?.lastChip}
          text={data?.lastText}
          cta={data?.lastCTA}
          partnerName={data.heroPartner.text}
          partnerImage={data.heroPartner.photo}
          toggleCountdown={false}
          textClassName=" w-[min(128rem,100%)] prose-h2:w-full prose-h2:[text-wrap-style:balance] [&_br]:hidden lg:[&_br]:block prose-h2:mb-[2rem]"
        />
        {data?.settings?.footer && (
          <Footer
            data={data.settings.footer}
            slug={data?.settings?.slug?.current}
          />
        )}
      </main>
    </>
  );
}
